import { TranslateService } from '@ngx-translate/core';
import { valueOrEmpty } from './predicates';

/** Estructura comun de name en respuestas del toolbox */
interface TranslatableName {
  key: string;
  default: string;
}

/**
 * Traduce un campo { key, default } del toolbox usando i18n.
 * Si la clave existe en las traducciones, la usa; si no, retorna el default.
 */
export function translateOption(
  name: TranslatableName | null | undefined,
  translate: TranslateService
): string {
  if (!name) {
    return '';
  }
  const key = valueOrEmpty(name.key);
  if (key) {
    const translated = translate.instant(key);
    if (translated !== key) {
      return translated;
    }
  }
  return valueOrEmpty(name.default);
}